<div class="grid-item grid-xs-12 grid full-width">
  <a
    [href]="link"
    target="_blank"
    class="card card-borderless bg-blue-cover full-width rounded-s"
  >
    <picture>
      <source [srcset]="imgWebp" type="image/webp" />
      <img
        class="card-background card-background-right"
        loading="lazy"
        decoding="auto"
        alt=""
        [src]="imgPng"
      />
    </picture>
    <div
      class="card-body grid grid-column justify-content-between mr-112"
      style="padding: 20px 24px"
    >
      <div
        class="typography typography-headline typography-paragraph typography-medium grey-800"
      >
        Пример результата
      </div>
      <div class="grid grid-gutter-12 grid-nowrap align-items-center">
        <div class="hidden-sm grid-item">
          <div class="typography typography-caption grey-800">
            Скачать&nbsp;файл
          </div>
        </div>

        <div class="hidden block-sm grid-item">
          <div class="typography typography-body grey-800">
            Скачать&nbsp;файл
          </div>
        </div>

        <div class="grid-item">
          <div
            class="icon icon-arrow-right-3 icon-20 shadow-white-plus rounded-circle"
          ></div>
        </div>
      </div>
    </div>
  </a>
</div>
